var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 24.0625V21.1458",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.22356 27.4819C6.55151 29.9177 8.56903 31.8259 11.0242 31.9388C13.0901 32.0338 15.1887 32.0833 17.4997 32.0833C19.8107 32.0833 21.9093 32.0338 23.9751 31.9388C26.4304 31.8259 28.4478 29.9177 28.7758 27.4819C28.9898 25.8923 29.1664 24.2632 29.1664 22.6042C29.1664 20.9452 28.9898 19.3161 28.7758 17.7265C28.4478 15.2906 26.4304 13.3824 23.9751 13.2695C21.9093 13.1745 19.8107 13.125 17.4997 13.125C15.1887 13.125 13.0901 13.1745 11.0242 13.2695C8.56903 13.3824 6.55151 15.2906 6.22356 17.7265C6.00954 19.3161 5.83301 20.9452 5.83301 22.6042C5.83301 24.2632 6.00954 25.8923 6.22356 27.4819Z",
    stroke: "white",
    strokeWidth: 1.5625
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9375 13.125V9.47916C10.9375 5.85479 13.8756 2.91666 17.5 2.91666C21.1244 2.91666 24.0625 5.85479 24.0625 9.47916V13.125",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobAccess);
export default __webpack_public_path__ + "static/media/JobAccess.61bb4fa16241227326774c684fef0f05.svg";
export { ForwardRef as ReactComponent };